import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import TollsContainer from './TollsContainer';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: TollsContainer,
  [TILE_LIBRARY_TYPES.JSLA]: TollsContainer,
};
